export const RECEIVE_CHANNELS = "RECEIVE_CHANNELS";
export const receiveChannels = (channels) => ({
  type: RECEIVE_CHANNELS,
  data: channels,
});

export const fetchChannel = (id) => {
  return async (dispatch) => {
    const response = await fetch(`/api/channel/${id}`);
    const data = await response.json();
    dispatch(receiveChannels([data]));
  };
};

export const fetchActiveChannels = () => {
  return async (dispatch) => {
    const response = await fetch(`/api/channel/`);
    const data = await response.json();
    dispatch(receiveChannels(data));
  };
};
